import React, { useEffect } from "react";

import StripeSplitForm from "../billing/stripe-split-form";

const WrappedStripeSplitForm = ({ clearState, ...otherProps }) => {
    useEffect(
        () => () => {
            if (clearState) {
                clearState();
            }
        },
        []
    );

    return <StripeSplitForm {...otherProps} />;
};

export default WrappedStripeSplitForm;
